<ng-container *ngIf="isBrowser()">
    <div class="tmp-section-item-wrapper">
        <span class="tmp-section-title">{{'Hotelkategorie ab' | i18n | async}}</span>
        <div class="tmp-section-body">
            @for (k of tmparr; track $index) {
            <button (click)="select(k)">
                <mat-icon class="tmp-stars">{{ k <= selectedCat() ? 'star' : 'star_border' }}</mat-icon>
            </button>
            }
        </div>
    </div>
</ng-container>